import React from 'react';
export default function chevronUp(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size || "72.656"} height={props.size || "72.656"} {...props} viewBox="0 0 63.968 38.82">
  <path d="M35.3-46.505a3.515,3.515,0,0,0-4.972,0L1.858-18.037a3.516,3.516,0,0,0,0,4.972l3.32,3.32a3.516,3.516,0,0,0,4.966.006L32.812-32.3,55.48-9.739a3.516,3.516,0,0,0,4.966-.006l3.32-3.32a3.516,3.516,0,0,0,0-4.972Z" transform="translate(-0.829 47.535)"/>
</svg>);
}

